import { forwardRef } from "react";
import { motion } from "framer-motion";

interface RouteAnimationProps {
  id?: string;
  animationKey?: string;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  onScroll?: (event: React.UIEvent<HTMLElement>) => void;
}

export const RouteAnimation = forwardRef<HTMLDivElement, RouteAnimationProps>(
  ({ animationKey, children, className, id, style, onScroll }, ref) => {
    return (
      <motion.main
        animate={{ opacity: 1 }}
        className={className}
        id={id}
        initial={{ opacity: 0 }}
        key={animationKey}
        ref={ref}
        style={style}
        transition={{ duration: 0.35 }}
        onScroll={onScroll}
      >
        {children}
      </motion.main>
    );
  }
);
